import { render } from "./ProfessionMatching.vue?vue&type=template&id=201362b2&scoped=true"
import script from "./ProfessionMatching.vue?vue&type=script&lang=js"
export * from "./ProfessionMatching.vue?vue&type=script&lang=js"

import "./ProfessionMatching.vue?vue&type=style&index=0&id=201362b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201362b2"]])

export default __exports__